import { ResponsePaginationInfo } from './pagination-info.entity';
import { Paginated } from '../../../../../core/http/entities/paginated.entity';

export interface PaginatedResults<T> {
    paginationInfo: ResponsePaginationInfo;
    results: T[];
}

export namespace PaginatedResults {
    export function fromPaginated<T>(paginated: Paginated<T>): PaginatedResults<T> {
        return {
            results: paginated.Results,
            paginationInfo: {
                page: Math.floor(paginated.StartIndex / paginated.NrOfResults),
                resultsPerPage: paginated.NrOfResults,
                totalNumberOfResults: paginated.TotalNrOfResults
            }
        }
    }
}
